<template>
  <div class="form_group_wrapper" :class="classes">
    <label
      v-if="label"
      :class="{
        form_group_wrapper__error: error,
        label_bold: !normalLabel,
        label_normal: normalLabel,
      }"
      :style="error ? 'color: #c93e63' : ''"
    >
      {{ label }} {{ isRequired ? '*' : '' }}
    </label>
    <p
      v-if="description"
      v-html="description"
      class="form_group_description"
    ></p>
    <div
      v-show="hasDefaultSlot"
      class="field"
      :class="{ loading: this.loading }"
    >
      <slot></slot>
      <label v-if="error" class="error">{{ error }}</label>
    </div>
  </div>
</template>

<script>
export default {
  name: 'VvsControlWrapper',
  props: {
    label: {
      type: String,
      required: null,
    },
    isRequired: {
      type: Boolean,
      default: false,
    },
    error: {
      type: String,
      default: null,
    },
    classes: {
      default: null,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    normalLabel: {
      type: Boolean,
      default: false,
    },
    description: {
      type: String,
      default: null,
    },
  },
  computed: {
    hasDefaultSlot() {
      return !!this.$slots.default;
    },
  },
};
</script>
